// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopularLocationSlider-positionRelative-FWdSq {
	position: relative;
}

.PopularLocationSlider-paddingNone-Ryxxg {
	padding: 0 !important;
}

@media(max-width:1200px) {
	.PopularLocationSlider-displayNone-HX2Yp {
		display: none !important;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Home/PopularLocationSlider/PopularLocationSlider.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC;EACC,wBAAwB;CACzB;AACD","sourcesContent":[".positionRelative {\n\tposition: relative;\n}\n\n.paddingNone {\n\tpadding: 0 !important;\n}\n\n@media(max-width:1200px) {\n\t.displayNone {\n\t\tdisplay: none !important;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"positionRelative": `PopularLocationSlider-positionRelative-FWdSq`,
	"paddingNone": `PopularLocationSlider-paddingNone-Ryxxg`,
	"displayNone": `PopularLocationSlider-displayNone-HX2Yp`
};
module.exports = ___CSS_LOADER_EXPORT___;
